import React from 'react';
import { DollarSign, Calendar, Percent } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../mock';

export const SeasonalPricing = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <div className="pb-6 mb-6 border-b">
      <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <DollarSign className="h-5 w-5" />
        {t.pricingTitle}
      </h3>
      
      <div className="space-y-4">
        {t.seasonalPrices.map((season, index) => (
          <div 
            key={index} 
            className="flex justify-between items-center"
          >
            <div>
              <h4 className="font-medium text-gray-900">{season.season}</h4>
              <p className="text-sm text-gray-600 flex items-center gap-1 mt-0.5">
                <Calendar className="h-3 w-3" />
                {season.dates}
              </p>
            </div>
            <div className="text-right">
              <p className="text-xl font-bold text-gray-900">
                {season.price}
              </p>
              <p className="text-xs text-gray-500">{season.unit}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="pt-4 mt-4 space-y-2 border-t border-gray-200">
        <p className="text-sm text-gray-600 flex items-center gap-2">
          <Calendar className="h-4 w-4" />
          {t.minStay}
        </p>
        <p className="text-sm text-gray-600 flex items-center gap-2">
          <Percent className="h-4 w-4" />
          {t.weeklyDiscount}
        </p>
      </div>
    </div>
  );
};
